import { render, staticRenderFns } from "./SgsstResponsabilitiesAPI.vue?vue&type=template&id=279f2c68&"
import script from "./SgsstResponsabilitiesAPI.vue?vue&type=script&lang=js&"
export * from "./SgsstResponsabilitiesAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports